// src/app/shared/name-change-requests/dummyData.ts
export interface NameChangeDataInterface {
  id: string;
  currentName: string;
  requestedName: string;
  reason: string;
  dateRequested: string; // ISO
  status: "pending" | "approved" | "rejected";
}

export const nameChangeData: NameChangeDataInterface[] = [
  {
    id: "req-1",
    currentName: "John Doe",
    requestedName: "JDoe",
    reason: "Prefer initials for privacy",
    dateRequested: "2025-05-01T10:15:00.000Z",
    status: "pending",
  },
  {
    id: "req-2",
    currentName: "Jane Smith",
    requestedName: "J.Snow",
    reason: "Stage name",
    dateRequested: "2025-05-02T11:00:00.000Z",
    status: "pending",
  },
  {
    id: "req-3",
    currentName: "Alice Johnson",
    requestedName: "Alicia J",
    reason: "Branding",
    dateRequested: "2025-05-03T09:30:00.000Z",
    status: "approved",
  },
  {
    id: "req-4",
    currentName: "Bob Williams",
    requestedName: "BWills",
    reason: "Shorter handle",
    dateRequested: "2025-05-04T14:45:00.000Z",
    status: "rejected",
  },
  {
    id: "req-5",
    currentName: "Carol Martinez",
    requestedName: "CaroM",
    reason: "Personal preference",
    dateRequested: "2025-05-05T08:20:00.000Z",
    status: "pending",
  },
  {
    id: "req-6",
    currentName: "David Brown",
    requestedName: "DBro",
    reason: "Simplify name",
    dateRequested: "2025-05-06T16:05:00.000Z",
    status: "approved",
  },
  {
    id: "req-7",
    currentName: "Eve Davis",
    requestedName: "E.Davis",
    reason: "Consistent branding",
    dateRequested: "2025-05-07T12:10:00.000Z",
    status: "pending",
  },
  {
    id: "req-8",
    currentName: "Frank Miller",
    requestedName: "F.Mills",
    reason: "Actor stage name",
    dateRequested: "2025-05-08T13:55:00.000Z",
    status: "approved",
  },
  {
    id: "req-9",
    currentName: "Grace Lee",
    requestedName: "GLee",
    reason: "Privacy",
    dateRequested: "2025-05-09T07:40:00.000Z",
    status: "rejected",
  },
  {
    id: "req-10",
    currentName: "Henry Clark",
    requestedName: "HClark",
    reason: "Cleaner look",
    dateRequested: "2025-05-10T15:25:00.000Z",
    status: "pending",
  },
];
